import { BaseOption } from '../model/BaseOption';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnumConverterService {
  constructor(private translationService: TranslateService) { }

  toBaseList(enumerationName, enumeration): Array<BaseOption> {
    const baseOptions: BaseOption[] = [];

    Object.keys(enumeration).filter(key => !Number(key) && key !== '0')
      .forEach(async key => {
        const translatedValue = await this.getTranslation(`${enumerationName}.${key}`);
        baseOptions.push(new BaseOption(key, translatedValue));
      });
    return baseOptions;
  }

  private async getTranslation(value): Promise<any> {
    await this.translationService.get(value).toPromise();
    return this.translationService.instant(value);
  }
}
